import { useDarkMode } from '@/hooks/useDarkMode'
import Uppy from '@uppy/core'
import Image from 'next/image'
import { useEffect, useMemo, useState } from 'react'
// import { Dashboard } from '@uppy/react'
import ImageKitPlugin from '@/lib/imagekit'
import ImageEditor from '@uppy/image-editor'

import { Title } from '@/components'

import fetchJson from '@/lib/fetcher'
import { XIcon } from '@heroicons/react/outline'
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import '@uppy/image-editor/dist/style.css'

const myLoader = ({ src }) => {
  return `${process.env.NEXT_PUBLIC_IMAGEKIT_URL_ENDPOINT}/${src}`
}

interface ImageStepProps {
  handleUpdate: (data: any) => void
  handleBack?: () => void
  canGoBack?: boolean
  data?: any
}

export const ImageUploader = ({ handleUpdate, handleBack, canGoBack = true, data = [] }: ImageStepProps) => {
  const [darkMode] = useDarkMode()
  const [uploadedImages, setUploadedImages] = useState([])

  useEffect(() => {
    setUploadedImages(data)
  }, [])

  const uppy = useMemo(() => {
    return new Uppy({
      allowMultipleUploads: true,
      autoProceed: false,
      restrictions: { maxFileSize: 10 ** 6 * 5, allowedFileTypes: ['image/*'] },
    })
      .use(ImageEditor, {
        quality: 0.8,
      })
      .use(ImageKitPlugin, {
        id: 'ImageKit',
      })
      .on('complete', (results) => {
        setUploadedImages([...uploadedImages, ...results.successful.map((result) => result.response.body)])
        handleUpdate([...results.successful.map((result) => result.response.body)])
      })
  }, [uploadedImages])

  useEffect(() => {
    return () => uppy.close()
  }, [])

  const handleFileDelete = async (fileId, id) => {
    try {
      await fetchJson('/api/images/delete', { method: 'delete' }, { fileId, id })
      const updatedArray = uploadedImages.filter((image) => image.fileId !== fileId)
      setUploadedImages(updatedArray)
      handleUpdate(uploadedImages)
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <>
      {/* <Dashboard
        width="100%"
        height="300px"
        uppy={uppy}
        hideUploadButton={false}
        plugins={['ImageEditor']}
        proudlyDisplayPoweredByUppy={false}
        note="Images up to 5mb only."
        theme={darkMode ? 'dark' : 'light'}
      /> */}
      <div className="my-6">
        {uploadedImages.length ? (
          <>
            <Title as="h3" size="md">
              Uploaded Images
            </Title>
            <ul className="mt-6 space-x-6 flex">
              {uploadedImages.map((image, idx) => (
                <li key={idx} className="relative">
                  <div className="rounded-lg overflow-hidden shadow-subtle h-[100px]">
                    <Image
                      loader={myLoader}
                      width="100"
                      height="100"
                      src={`tr:w-100,h-100${image.filePath}`}
                      className="rounded-lg mb-0 leading-none"
                    />
                  </div>
                  <button
                    title="Delete"
                    className="absolute -top-2 -right-2 rounded-full bg-rose-600 hover:bg-rose-800 p-1.5 transition"
                    onClick={() => handleFileDelete(image.fileId, image.id)}
                  >
                    <span className="sr-only">Delete File</span>
                    <XIcon className="text-white h-3" />
                  </button>
                </li>
              ))}
            </ul>
          </>
        ) : null}
      </div>
    </>
  )
}
